import Swiper, { Autoplay, Navigation, Pagination, Keyboard } from 'swiper'
import 'swiper/swiper-bundle.css'
import './styles.scss'

Swiper.use([ Autoplay, Navigation, Pagination, Keyboard ])

document.querySelectorAll('.baners-sale__small-slider').forEach((swiperContainer) => {
    const swiperSmall =  new Swiper(swiperContainer, {
        autoplay: true,
        delay: 4000,
    
        loop : true,
        
        navigation: {
            nextEl: swiperContainer.querySelector('.swiper-button-next'),
            prevEl: swiperContainer.querySelector('.swiper-button-prev'),
        },
        keyboard: {
            enabled: true,
            onlyInViewport: false,
        },
    })

    document.addEventListener("DOMContentLoaded", () => {
        setTimeout(() => {
            swiperSmall.update()
        }, 300)
    })
})